// ═══════════════════════════════════════════════════════════════════════════
// FINANCIAL SUBMENU - UrbanQ v1.9.6
// Overlay con subopciones del módulo financiero
// ═══════════════════════════════════════════════════════════════════════════

import React, { useEffect, useRef } from 'react';
import {
    FiPieChart, FiTrendingUp, FiTrendingDown, FiTarget,
    FiCalendar, FiSettings, FiX
} from 'react-icons/fi';
import './FinancialSubmenu.css';

const menuOptions = [
    {
        id: 'panel_financiero',
        icon: FiPieChart,
        title: 'Panel Financiero',
        description: 'Resumen de ingresos, gastos y KPIs',
        color: '#667eea'
    },
    {
        id: 'mis_ingresos',
        icon: FiTrendingUp,
        title: 'Ingresos',
        description: 'Registra y consulta tus ingresos',
        color: '#48bb78'
    },
    {
        id: 'mis_gastos',
        icon: FiTrendingDown,
        title: 'Gastos',
        description: 'Registra y consulta tus gastos',
        color: '#e53e3e'
    },
    {
        id: 'presupuesto',
        icon: FiTarget,
        title: 'Presupuesto',
        description: 'Planifica y controla tu presupuesto',
        color: '#ed8936'
    },
    {
        id: 'calendario',
        icon: FiCalendar,
        title: 'Calendario',
        description: 'Vista de calendario de movimientos',
        color: '#38b2ac'
    },
    {
        id: 'resumen_anual',
        icon: FiCalendar,
        title: 'Resumen Anual',
        description: 'Vista anual comparativa',
        color: '#4299e1'
    },
    {
        id: 'config_financiera',
        icon: FiSettings,
        title: 'Configuracion',
        description: 'Categorias, ano fiscal, moneda',
        color: '#9f7aea'
    }
];

export default function FinancialSubmenu({ isOpen, onClose, onSelect, currentOption }) {
    const panelRef = useRef(null);

    // Cerrar con ESC
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEsc);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    // Cerrar al hacer clic fuera
    const handleOverlayClick = (e) => {
        if (panelRef.current && !panelRef.current.contains(e.target)) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="financial-submenu-overlay" onClick={handleOverlayClick}>
            <div className="financial-submenu-panel" ref={panelRef}>
                <div className="financial-submenu-header">
                    <h2>
                        <FiPieChart />
                        <span>Sistema Financiero</span>
                    </h2>
                    <button className="financial-submenu-close" onClick={onClose}>
                        <FiX />
                    </button>
                </div>

                <p className="financial-submenu-subtitle">
                    Selecciona una opción para gestionar tus finanzas
                </p>

                <div className="financial-submenu-grid">
                    {menuOptions.map((option) => {
                        const Icon = option.icon;
                        const isActive = currentOption === option.id;

                        return (
                            <button
                                key={option.id}
                                className={`financial-submenu-card ${isActive ? 'active' : ''}`}
                                onClick={() => {
                                    onSelect(option.id);
                                    onClose();
                                }}
                                style={{ '--card-color': option.color }}
                            >
                                <div className="financial-submenu-card-icon">
                                    <Icon />
                                </div>
                                <div className="financial-submenu-card-content">
                                    <span className="financial-submenu-card-title">
                                        {option.title}
                                    </span>
                                    <span className="financial-submenu-card-desc">
                                        {option.description}
                                    </span>
                                </div>
                                {isActive && (
                                    <span className="financial-submenu-card-active">
                                        Activo
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

// Exportar las opciones para usar en breadcrumb
export { menuOptions };
